import notificationService from './notification.service';

const notificationModule = angular.module('app.common.notification', [])
	.service('notificationService', notificationService)
	.name;

export default notificationModule;
